import { API_BASE_URL } from "config/api";

async function ensureOk(res) {
    if (res.ok) return res;
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed (${res.status})`);
}

export const authApi = {

    getProfile: async () => {
        const token =
            localStorage.getItem("accessToken") || localStorage.getItem("token");

        const res = await fetch(`${API_BASE_URL}/api/auth/profile`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        await ensureOk(res);
        return await res.json();
    },

    updatePreferredLanguage: async (preferredLanguage) => {
        const token =
            localStorage.getItem("accessToken") || localStorage.getItem("token");

        const res = await fetch(`${API_BASE_URL}/api/auth/profile/language`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ preferredLanguage })
        });
        await ensureOk(res);
        return await res.json();
    },

    forgotPassword: async (email) => {
        const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
        });
        await ensureOk(res);
        return await res.text();
    },

    resetPassword: async (token, newPassword) => {
        const res = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token, newPassword }),
        });
        await ensureOk(res);
        return await res.text();
    },

    register: async (payload) => {
        const res = await fetch(`${API_BASE_URL}/api/auth/register`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });
        await ensureOk(res);
        return await res.text();
    },

    confirmRegistration: async (token) => {
        const res = await fetch(`${API_BASE_URL}/api/auth/confirm-registration`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token })
        });
        await ensureOk(res);
        return await res.text();
    },

    requestRole: async (roleName) => {
        const token =
            localStorage.getItem("accessToken") || localStorage.getItem("token");

        const res = await fetch(`${API_BASE_URL}/api/auth/request-role`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ roleName })
        });
        await ensureOk(res);
        return await res.text();
    },
};